import React from "react";
import { pure } from "recompose";

import { pickValue } from "./utils";
import { moneyFormatCents } from "./format";
import OnePanelChart from "./OnePanelChart";
import DivFormula from "./DivFormula";
import Text from "./Text";

const SharePrice = pure(({ constants, teams, competitionMetrics }) => (
  <OnePanelChart
    title="Share Price"
    prefix="$"
    data={pickValue(teams, competitionMetrics, "Share Price")}
    teams={teams}
  >
    <Text>
      Share price is synonymous with the term stock price. It represents the
      price an investor will pay to own 1 share of a company. At the start of
      the competition, all teams start out with a share price of{" "}
      {moneyFormatCents(constants.initial_share_price)}. Here’s the formula for
      Share Price.
    </Text>
    <DivFormula
      name1="SHARE PRICE"
      name2="YOUR BUSINESS VALUE"
      name3="SHARES OUTSTANDING"
    />
  </OnePanelChart>
));

export default SharePrice;



// WEBPACK FOOTER //
// ./src/components/analysis/SharePrice.js